import { newToolFilterOAuthMcp } from "../oauth.ts";

export const klaviyoMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.klaviyo.com/icons/icon-192x192.png",
  url: "https://mcp.klaviyo.com/mcp",
  label: "Klaviyo",
});
